/**
 * Узбекский набор строк.
 */

import type { Strings } from './index';

export const uz: Strings = {
  login_title: 'CargoPASS tizimiga kirish',
  login_phone_label: 'Telefon raqami',
  login_code_request: 'Kod olish',
  login_code_label: 'Xabardagi kod',
  login_code_submit: 'Kirish',
  login_failed: 'Kirib bo‘lmadi. Qaytadan urinib ko‘ring.',
  works_title: 'Ishlar',
  works_more: 'Yana ko‘rsatish',
  works_failed: 'Ro‘yxatni yuklab bo‘lmadi.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'Telefon orqali',
  login_channel_email: 'E-pochta orqali',
  login_email_label: 'E-pochta manzili',
  login_terms_label: 'Foydalanish shartlariga roziman',
  company_switcher_label: 'Firma',
  language_label: 'Til',
  state_loading: 'Yuklanmoqda…',
  state_empty: 'Hozircha hech narsa yo‘q',
  state_error: 'Ma’lumotni olib bo‘lmadi',
  state_no_access: 'Bu sahifa sizga ochiq emas',
  no_membership_title: 'Siz hech bir firmada emassiz',
  no_membership_explain: 'Ishlash uchun firmaga qo‘shiling yoki o‘zingiznikini oching.',
  company_create_submit: 'Firma ochish',
  company_name_label: 'Firma nomi',
  company_form_type_label: 'Firma turi',
  company_tax_id_label: 'Ro‘yxatga olish raqami',
  company_legal_address_label: 'Yuridik manzil',
  company_members_title: 'Firma xodimlari',
  not_found_title: 'Bunday sahifa yo‘q',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Mening profilim',
  profile_sessions_title: 'Faol seanslar',
  profile_session_current: 'Joriy seans',
  profile_session_never_used: 'Hech qachon ishlatilmagan',
  profile_session_created: 'Yaratilgan',
  profile_session_last_used: 'Oxirgi kirish',
  profile_session_terminate: 'Yakunlash',
  profile_channel_add: 'Aloqa kanalini qo‘shish',
  profile_channel_code_request: 'Kod yuborish',
  profile_channel_confirm: 'Kanalni tasdiqlash',
  members_title: 'Xodimlar',
  members_invite: 'Xodimni taklif qilish',
  invite_channel_phone: 'Telefon bilan',
  invite_channel_email: 'E-pochta bilan',
  invite_role_label: 'Rol',
  invite_submit: 'Taklifnomani yuborish',
  invitations_title: 'Taklifnomalar',
  invitation_revoke: 'Qaytarib olish',
  invitation_resend: 'Qayta yuborish',
  rights_title: 'Xodim huquqlari',
  rights_grants: 'Rol ustiga berilgan',
  rights_denies: 'Shaxsan taqiqlangan',
  rights_grant_add: 'Huquq berish',
  rights_deny_add: 'Taqiq qo‘yish',
  rights_remove: 'O‘chirish',
  company_profile_title: 'Firma profili',
  company_documents_title: 'Firma hujjatlari',
  company_type_transport: 'Tashuvchi',
  company_type_logistics: 'Logistika firmasi',
  member_documents_title: 'Xodim hujjatlari',
  document_download: 'Faylni ochish',
  enum_unknown: 'Noma’lum',
  role_director: 'Direktor',
  role_logist: 'Logist',
  role_dispatcher: 'Dispetcher',
  role_accountant: 'Buxgalter',
  role_mechanic: 'Mexanik',
  role_driver: 'Haydovchi',
  member_status_active: 'Amal qiladi',
  member_status_closed: 'Yopilgan',
  permission_company_staff_manage: 'Xodimlarni boshqarish',
  permission_company_rights_manage: 'Huquqlarni boshqarish',
  permission_company_fleet_manage: 'Avtoparkni boshqarish',
  permission_company_fleet_repair: 'Ta’mirni belgilash',
  permission_company_docs_manage: 'Hujjatlarni boshqarish',
  permission_company_listings_manage: 'E’lonlarni boshqarish',
  permission_company_cargo_take: 'Yuk olish',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Transport va haydovchi tayinlash',
  permission_company_accounting_manage: 'Firma xarajatlari va to‘lovlarini yuritish',
  document_status_pending: 'Tekshiruvda',
  document_status_verified: 'Tasdiqlangan',
  document_status_rejected: 'Rad etilgan',
  document_status_expired: 'Muddati tugagan',
  document_status_not_verified: 'Tasdiqlanmagan',
  invitation_status_pending: 'Javob kutilmoqda',
  invitation_status_accepted: 'Qabul qilindi',
  invitation_status_revoked: 'Bekor qilindi',
  invitation_status_expired: 'Muddati tugadi',

  // Ключи блока `WEB-1.3`: транспорт фирмы, цикл ремонта, сервисная история и
  // заявки на освобождение VIN.
  fleet_title: 'Firma transporti',
  fleet_add: 'Transport qo‘shish',
  fleet_added: 'Transport qo‘shildi',
  fleet_add_already: 'Bu transport reyestrda allaqachon bor',
  fleet_vin: 'VIN raqami',
  fleet_tech_passport: 'Texpasport raqami',
  fleet_kind_label: 'Transport turi',
  fleet_body_type_label: 'Kuzov turi',
  fleet_withdraw: 'Reyestrdan chiqarish',
  fleet_withdrawn_at: 'Chiqarilgan sana',
  fleet_empty: 'Reyestr hozircha bo‘sh',
  service_title: 'Mashina servisi',
  service_state_label: 'Texnik holat',
  service_state_change: 'Holatni o‘tkazish',
  service_records_title: 'Ishlar jurnali',
  service_record_add: 'Yozuv kiritish',
  service_description: 'Nima qilindi, qaysi uzellar',
  service_parts: 'Ehtiyot qismlar',
  service_cost: 'Xarajat',
  service_currency: 'Valyuta',
  service_records_empty: 'Hozircha yozuvlar yo‘q',
  vin_claims_title: 'VIN bo‘shatish arizalari',
  vin_claim_create: 'Ariza berish',
  vin_claim_object: 'E’tiroz bildirish',
  vin_claim_window_ends_at: 'E’tiroz oynasi tugashi',
  vin_claims_empty: 'Hozircha arizalar yo‘q',
  vehicle_kind_tractor: 'Tyagach',
  vehicle_kind_trailer: 'Tirkama',
  body_type_tarpaulin: 'Tentli',
  body_type_refrigerator: 'Refrijerator',
  body_type_isothermal: 'Izotermik',
  body_type_box: 'Furgon',
  body_type_flatbed: 'Bortli',
  body_type_platform: 'Platforma',
  body_type_lowbed: 'Tral',
  body_type_mega: 'Mega-kuzov',
  body_type_car_carrier: 'Avtotashuvchi',
  body_type_tipper: 'Ag‘dargich',
  body_type_walking_floor: 'Suriluvchi pol',
  body_type_tank: 'Sisterna',
  body_type_silo: 'Silos-sisterna',
  body_type_container_chassis: 'Konteyner tashuvchi',
  body_type_bdf: 'BDF kuzovi',
  body_type_timber: 'Yog‘och tashuvchi',
  body_type_livestock: 'Mol tashuvchi',
  body_type_coil: 'Rulon tashuvchi',
  body_type_heavy_haul: 'Og‘ir yuk trali',
  body_type_extendable: 'Uzaytiriladigan',
  repair_state_fault_detected: 'Nosozlik aniqlangan',
  repair_state_in_repair: 'Ta’mirda',
  repair_state_repaired: 'Ta’mirlangan',
  repair_state_ready: 'Tayyor',
  vehicle_status_active: 'Reyestrda',
  vehicle_status_withdrawn: 'Chiqarilgan',
  vin_claim_status_pending: 'E’tiroz oynasi ochiq',
  vin_claim_status_objected: 'E’tiroz berilgan',
  vin_claim_status_awaiting_admin: 'Xodimlar qarorini kutmoqda',
  vin_claim_direction_outgoing: 'Bizning ariza',
  vin_claim_direction_incoming: 'Bizga kelgan ariza',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Peregonni kuzatish',
  tracking_pin_hint: 'Buyurtmachi havola bilan birga bergan olti xonali PIN kodni kiriting. PIN kodsiz sahifa hech narsa ko‘rsatmaydi.',
  tracking_pin_label: 'Olti xonali PIN kod',
  tracking_pin_submit: 'Ochish',
  tracking_offline: 'Aloqa yo‘q. Internetni tekshirib, qaytadan urinib ko‘ring.',
  tracking_offline_refresh: 'Aloqa yo‘q — aloqa tiklanganda yangilanadi.',
  tracking_status_changed_at: 'Holat o‘zgargan',
  tracking_vehicle: 'Mashina',
  tracking_route: 'Yo‘nalish',
  tracking_distance: 'Masofa',
  tracking_transit: 'Tranzit',
  tracking_border_crossings: 'Chegara kesishuvlari',
  tracking_last_position: 'Oxirgi nuqta',
  tracking_no_position: 'Joylashuv hali kelmadi',
  tracking_open_map: 'Xaritada ochish',
  tracking_photos: 'Mashinani qabul qilish',
  tracking_photo_open: 'Suratni ochish',
  tracking_photo_plate: 'Davlat raqami',
  tracking_photo_close: 'Yopish',
  tracking_milestones: 'Bosqichlar',
  tracking_locked_title: 'Havola vaqtincha ishlamayapti',
  tracking_retry: 'PIN kodni qayta kiritish',
  tracking_gone_title: 'Havola amal qilmaydi',
  tracking_map_title: 'Xarita: oxirgi nuqta',
  work_status_CREATED: 'Yaratildi',
  work_status_ASSIGNED: 'Tayinlandi',
  work_status_ACCEPTED: 'Ijroga qabul qilindi',
  work_status_AT_PICKUP: 'Yuklashda',
  work_status_AT_HANDOVER: 'Mashina qabuli',
  work_status_IN_TRANSIT: 'Yo‘lda',
  work_status_DELIVERED: 'Topshirildi',
  work_status_COMPLETED: 'Yakunlandi',
  work_status_CANCELLED: 'Bekor qilindi',
  work_status_ARCHIVED: 'Arxivda',
  peregon_vehicle_kind_tractor: 'Tyagach',
  peregon_vehicle_kind_tractor_with_trailer: 'Tirkamali tyagach',
  peregon_vehicle_kind_car: 'Yengil avtomobil',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  cargo_listings_title: 'Yuk e’lonlari',
  cargo_listings_create: 'E’lon berish',
  cargo_listings_more: 'Yana ko‘rsatish',
  cargo_listings_empty: 'Hozircha e’lonlar yo‘q',
  cargo_listing_edit: 'Tahrirlash',
  cargo_listing_close: 'Yopish',
  cargo_listing_close_confirm: 'E’lon yopilsinmi? Yopilgan e’lon lentaga qaytmaydi.',
  cargo_listing_km: 'km',
  cargo_listing_kg: 'kg',
  cargo_listing_days: 'kun',
  cargo_listing_transit: 'Tranzit',
  cargo_listing_borders: 'Chegaradan o‘tishlar',
  cargo_listing_slots_free: 'Bo‘sh',
  cargo_listing_slots_of: 'ta, jami',
  cargo_listing_fixed: 'Narx qat’iy',
  cargo_listing_payment: 'To‘lov',
  cargo_listing_form_title_new: 'Yangi yuk e’loni',
  cargo_listing_form_title_edit: 'Yuk e’lonini tahrirlash',
  cargo_listing_form_origin: 'Yuklash shahri',
  cargo_listing_form_destination: 'Tushirish shahri',
  cargo_listing_form_city_search: 'Shahar nomini yoza boshlang',
  cargo_listing_form_loading_at: 'Yuklash sanasi',
  cargo_listing_form_unload_by: 'Tushirish muddati',
  cargo_listing_form_vehicles_count: 'Nechta mashina kerak',
  cargo_listing_form_cargo_type: 'Yuk',
  cargo_listing_form_weight: 'Bir mashinaga og‘irlik, kg',
  cargo_listing_form_adr: 'Xavfli yuk (ADR)',
  cargo_listing_form_body_type: 'Kuzov turi',
  cargo_listing_form_body_subtype: 'Kuzovning kichik turi',
  cargo_listing_form_temperature_from: 'dan',
  cargo_listing_form_temperature_to: 'gacha',
  cargo_listing_form_price: 'Bir mashina narxi',
  cargo_listing_form_currency: 'Valyuta',
  cargo_listing_form_negotiable: 'Kelishsa bo‘ladi',
  cargo_listing_form_payment_method: 'To‘lov usuli',
  cargo_listing_form_payment_moment: 'To‘lov vaqti',
  cargo_listing_form_deferral_days: 'Kechiktirish kunlari',
  cargo_listing_form_comment: 'Izoh',
  cargo_listing_form_submit: 'E’lonni joylash',
  cargo_listing_form_save: 'O‘zgarishlarni saqlash',
  cargo_offers_title: 'Tashuvchilar takliflari',
  cargo_offer_accept: 'Ma’qullash',
  cargo_offer_decline: 'Rad etish',
  cargo_offer_decline_confirm: 'Taklif rad etilsinmi? Tashuvchi rad javobini ko‘radi.',
  cargo_offer_agrees: 'Shartlaringizga rozi',
  cargo_offer_counter: 'O‘z narxini taklif qilmoqda',
  cargo_offer_documents_verified: 'Hujjatlari tekshirilgan',
  cargo_offer_vehicles: 'Mashinalar',
  cargo_offer_price: 'Tashuvchi narxi',
  cargo_offer_listing_price: 'E’londagi narx',
  cargo_offer_expires: 'Javob muddati',
  cargo_offer_more: 'Yana takliflar',
  cargo_slots_title: 'Buyurtma taxtasi',
  cargo_slot_work: 'Ish',
  listing_status_OPEN: 'Ochiq',
  listing_status_TAKEN: 'Barcha mashinalar topildi',
  listing_status_CLOSED: 'Yopilgan',
  listing_status_CANCELLED: 'Bekor qilingan',
  listing_status_PENDING_REVIEW: 'Tekshiruvda',
  listing_status_REJECTED: 'Rad etilgan',
  cargo_offer_status_PENDING: 'Qaror kutilmoqda',
  cargo_offer_status_APPROVED: 'Ma’qullangan — tashuvchi tasdig‘i kutilmoqda',
  cargo_offer_status_CONFIRMED: 'Tashuvchi tasdiqlagan',
  cargo_offer_status_REJECTED: 'Rad etilgan',
  cargo_offer_status_WITHDRAWN: 'Tashuvchi qaytarib olgan',
  cargo_offer_status_EXPIRED: 'Muddati o‘tgan',
  cargo_offer_status_SUPERSEDED: 'Bo‘sh mashina qolmadi',
  cargo_offer_status_CANCELLED: 'Barcha ishlar bekor qilindi',
  cargo_slot_status_OPEN: 'Bo‘sh',
  cargo_slot_status_RESERVED: 'Tashuvchi tasdig‘i kutilmoqda',
  cargo_slot_status_TAKEN: 'Band',
  cargo_slot_status_CANCELLED: 'Bekor qilingan',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (so‘m)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Naqd pul',
  payment_method_bank_transfer: 'Hisob raqamiga o‘tkazma',
  payment_moment_prepayment: 'Oldindan to‘lov',
  payment_moment_on_unloading: 'Tushirishda',
  payment_moment_deferred: 'Kechiktirib',
  loading_type_rear: 'Orqadan',
  loading_type_side: 'Yon tomondan',
  loading_type_top: 'Yuqoridan',
  loading_type_full_uncover: 'To‘liq ochib',
  body_parameter_length_m: 'Uzunligi, m',
  body_parameter_width_m: 'Kengligi, m',
  body_parameter_height_m: 'Balandligi, m',
  body_parameter_volume_m3: 'Hajmi, m³',
  body_parameter_capacity_t: 'Yuk ko‘tarishi, t',
  body_parameter_loading_type: 'Yuklash usuli',
  body_parameter_temperature: 'Harorat, °C',
  body_parameter_cars_capacity: 'Sig‘imi, avtomobil',

  // Ключи блока `WEB-2.2`: кабинет диспетчера — лента грузов, offer, работы
  // фирмы, назначение транспорта и водителя, причины недоступности машины.
  cargo_feed_title: 'Yuklar lentasi',
  cargo_feed_filters: 'Filtrlar',
  cargo_feed_apply: 'Qo‘llash',
  cargo_feed_reset: 'Tozalash',
  cargo_feed_more: 'Yana ko‘rsatish',
  cargo_feed_details: 'Batafsil',
  cargo_feed_company_verified: 'Firma tekshirilgan',
  cargo_feed_adr: 'Xavfli yuk (ADR)',
  cargo_feed_empty: 'Mos keladigan e’lonlar yo‘q',
  cargo_feed_loading_from: 'Yuklash sanasi, dan',
  cargo_feed_loading_to: 'Yuklash sanasi, gacha',
  cargo_feed_vehicles_min: 'Mashinalar soni, kamida',
  cargo_feed_weight_from: 'Og‘irligi, kg dan',
  cargo_feed_weight_to: 'Og‘irligi, kg gacha',
  cargo_feed_body_type: 'Kuzov turi',
  cargo_feed_temperature: 'Harorat rejimi',
  cargo_feed_price_from: 'Bir mashina narxi, dan',
  cargo_feed_price_to: 'Bir mashina narxi, gacha',
  cargo_feed_currency: 'Narx valyutasi',
  cargo_feed_q: 'Kalit so‘z',
  cargo_feed_any: 'Farqi yo‘q',
  cargo_feed_yes: 'Ha',
  cargo_feed_no: 'Yo‘q',
  cargo_feed_cities_title: 'Jo‘nash shaharlari',
  cargo_feed_cities_total: 'Jami e’lonlar',
  cargo_feed_date_hint: 'YYYY-OO-KK',
  cargo_feed_my_offer: 'Firmangiz taklifi',
  cargo_feed_listing_no_right: 'Taklifni yuk olish huquqi bor xodim yubora oladi — bu huquqni direktor beradi',
  cargo_feed_listing_unavailable: 'Bu firmadan ushbu e’longa hozir taklif yuborib bo‘lmaydi',
  cargo_feed_listing_agree: 'Shartlaringizga roziman',
  cargo_feed_listing_own_price: 'O‘z narxim',
  cargo_feed_listing_fixed_price: 'Narx qat’iy',
  cargo_feed_listing_negotiable: 'Narx bo‘yicha kelishsa bo‘ladi',
  cargo_feed_listing_submit: 'Taklif yuborish',
  cargo_feed_listing_price_amount: 'Bir mashina uchun narxingiz',
  cargo_offers_mine_title: 'Mening takliflarim',
  cargo_offers_confirm: 'Tasdiqlash',
  cargo_offers_withdraw: 'Qaytarib olish',
  cargo_offers_withdraw_confirm: 'Taklif qaytarib olinsinmi? Logist uni endi ko‘rib chiqmaydi.',
  cargo_offers_more: 'Yana takliflarni ko‘rsatish',
  cargo_offers_agrees: 'Shartlarga rozilik',
  cargo_offers_counter: 'O‘z narxi',
  cargo_offers_vehicles: 'Mashinalar',
  cargo_offers_empty: 'Takliflar hali yo‘q',
  cargo_offers_price: 'Bir mashina narxi',
  cargo_offers_expires: 'Logist javobi muddati',
  cargo_offers_confirm_by: 'Tasdiqlash muddati',
  cargo_offers_sender: 'Yuborgan',
  works_to_assign_title: 'Tayinlashni kutayotganlar',
  works_to_assign_empty: 'Tayinlashni kutayotgan ishlar yo‘q',
  works_empty: 'Ishlar hali yo‘q',
  works_assign: 'Tayinlash',
  works_replace: 'Almashtirish',
  work_assignment_title: 'Transport va haydovchini tayinlash',
  work_assignment_tractor: 'Tyagach',
  work_assignment_trailer: 'Tirkama',
  work_assignment_driver: 'Haydovchi',
  work_assignment_no_trailer: 'Tirkamasiz',
  work_assignment_driver_busy: 'Band',
  work_assignment_unnamed: 'Ism ko‘rsatilmagan',
  work_assignment_assign: 'Tayinlash',
  work_assignment_replace: 'Almashtirish',
  work_assignment_current: 'Hozir tayinlangan',
  work_assignment_assigned_at: 'Tayinlangan vaqti',
  work_assignment_history: 'Biriktirishlar tarixi',
  work_assignment_history_empty: 'Almashtirishlar bo‘lmagan',
  work_assignment_assigned_by: 'Tayinlagan',
  work_assignment_replaced_by: 'Olib tashlagan',
  work_assignment_unavailable: 'Bu ish uchun tayinlash va almashtirish hozir mumkin emas',
  unassignable_reason_withdrawn: 'Reyestrdan chiqarilgan',
  unassignable_reason_not_ready: 'Reysga tayyor emas',
  unassignable_reason_busy: 'Boshqa ishda band',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  vehicle_card_title: 'Mashina kartochkasi',
  vehicle_photo_title: 'Mashina suratlari',
  vehicle_photo_file: 'Suratni tanlang',
  vehicle_photo_add: 'Surat qo‘shish',
  vehicle_photo_delete: 'O‘chirish',
  vehicle_photo_delete_confirm: 'Mashinaning bu suratini o‘chirasizmi?',
  vehicle_photo_empty: 'Hozircha suratlar yo‘q',
  vehicle_fault_title: 'Ochiq nosozliklar',
  vehicle_fault_empty: 'Ochiq nosozliklar yo‘q',
  vehicle_fault_author_unknown: 'Muallif ko‘rsatilmagan',
  vehicle_fault_comment: 'Mashinada nima nosoz',
  vehicle_fault_photos: 'Nosozlik suratlari',
  vehicle_fault_add: 'Nosozlikni yozish',
  vehicle_fault_history: 'Barcha nosozliklar',
  vehicle_fault_open: 'Ochiq',
  vehicle_fault_closed: 'Yopilgan',
  vehicle_fault_history_empty: 'Mashinada nosozliklar bo‘lmagan',
  drivers_title: 'Firma haydovchilari',
  drivers_age: 'Yoshi:',
  drivers_name_unknown: 'Ismi ko‘rsatilmagan',
  drivers_not_specified: 'ko‘rsatilmagan',
  drivers_self_reported: 'Ism, yosh va jinsni insonning o‘zi ko‘rsatgan',
  drivers_documents: 'Hujjatlar',
  drivers_empty: 'Hozircha haydovchilar yo‘q',
  service_part_add: 'Qator qo‘shish',
  service_part_remove: 'Olib tashlash',
  service_part_name: 'Ehtiyot qism nomi',
  service_part_quantity: 'Soni',
  vin_claim_file_label: 'Texpasport fayli — surat yoki PDF',
  vin_claim_file_link: 'Texpasport',
  vin_claim_file_missing: 'Faylsiz berilgan',
  profile_birth_date: 'Tug‘ilgan sana',
  profile_gender: 'Jinsi',
  profile_gender_unspecified: 'Ko‘rsatilmagan',
  profile_personal_note: 'Insonning o‘zi ko‘rsatgan',
  profile_personal_hint: 'Sizga ko‘rinadi; firma a’zolariga — faqat yosh va jins',
  profile_personal_save: 'Saqlash',
  gender_male: 'Erkak',
  gender_female: 'Ayol',
  document_type_passport: 'Pasport',
  document_type_driver_license: 'Haydovchilik guvohnomasi',
  document_type_adr_certificate: 'ADR guvohnomasi',
  document_type_professional_certificate: 'Kasbiy guvohnoma',
  document_type_face_snapshot: 'Yuz surati',
  document_type_tachograph_card: 'Taxograf kartasi',
  document_type_code95_card: '«Kod 95» kartasi',
  document_type_visa: 'Viza',
  document_type_registration_certificate: 'Ro‘yxatdan o‘tganlik guvohnomasi',
  expenses_title: 'Xarajatlar',
  expenses_create: 'Xarajatni yozish',
  expenses_delete_confirm: 'Bu xarajatni o‘chirasizmi?',
  expenses_empty: 'Hozircha xarajatlar yo‘q',
  expense_form_submit: 'Xarajatni saqlash',
  expense_form_category: 'Turkum',
  expense_form_spent_on: 'Xarajat sanasi',
  expense_form_vehicle: 'Mashina',
  expense_form_receipt: 'Chek — surat yoki PDF',
  expense_receipt_refreshed: 'Chek havolasi yangilandi — qaytadan oching',
  expense_receipt_replace_hint: 'yangi fayl avvalgisining o‘rnini oladi',
  payouts_title: 'To‘lovlar',
  payouts_create: 'To‘lovni yozish',
  payouts_delete_confirm: 'Bu to‘lovni o‘chirasizmi?',
  payouts_empty: 'Hozircha to‘lovlar yo‘q',
  payout_form_submit: 'To‘lovni saqlash',
  payout_form_recipient: 'Oluvchi',
  payout_form_paid_on: 'To‘lov sanasi',
  payout_recipient_unnamed: 'Ismi ko‘rsatilmagan',
  payout_recipient_not_listed: 'Firma haydovchilari ro‘yxatida yo‘q',
  payout_recipient_unavailable: 'Oluvchining ismi mavjud emas',
  payout_recipient_loading: 'Oluvchi yuklanmoqda…',
  accounting_edit: 'O‘zgartirish',
  accounting_delete: 'O‘chirish',
  accounting_more: 'Yana ko‘rsatish',
  accounting_works_more: 'Yana ishlarni ko‘rsatish',
  accounting_filter_reset: 'Tozalash',
  accounting_filter_empty: 'Bu saralash bo‘yicha yozuvlar yo‘q',
  accounting_filter_any: 'Barchasi',
  accounting_work_fallback: 'Ish',
  accounting_vehicle_fallback: 'Mashina',
  accounting_vehicle_missing: 'Mashina reyestrda topilmadi',
  accounting_no_vehicle: 'Mashinasiz',
  accounting_no_work: 'Ishga bog‘lanmagan',
  accounting_field_amount: 'Summa',
  accounting_field_currency: 'Valyuta',
  accounting_field_work: 'Ish',
  accounting_field_comment: 'Izoh',
  accounting_choose: 'Tanlang',
  accounting_form_close: 'Bekor qilish',
  expense_category_diesel: 'Dizel yoqilg‘isi',
  expense_category_parking: 'To‘xtash joyi',
  expense_category_toll: 'Pullik yo‘l',
  expense_category_service: 'Texnik xizmat va ta’mir',
  expense_category_other: 'Boshqa',
  state_retry: 'Qayta urinish',
  member_unnamed: 'Ism ko‘rsatilmagan',
  work_card_not_available: 'Ish mavjud emas',
  work_card_status: 'Holat',
  work_card_price: 'Ish narxi',
  work_card_vehicle: 'Mashina',
  work_card_vehicle_model: 'Mashina modeli',
  work_card_auto_completed: 'Avtomatik yakunlangan',
  work_card_confirm: 'Yetkazishni tasdiqlash',
  work_card_confirm_question: 'Yetkazish tasdiqlansinmi? Ish yakunlanadi.',
  work_card_confirm_by: 'Tasdiqlash muddati',
  work_card_verified: 'Hujjatlar tekshirilgan',
  work_card_not_verified: 'Hujjatlar tekshirilmagan',
  work_card_parties: 'Tomonlar',
  work_card_customer: 'Buyurtmachi',
  work_card_executor: 'Ijrochi',
  work_card_assignment: 'Transport va haydovchi',
  work_card_assignment_empty: 'Transport va haydovchi hali tayinlanmagan',
  work_card_cargo: 'Yuk',
  work_card_cargo_type: 'Yuk turi',
  work_card_cargo_loading: 'Yuklash sanasi',
  work_card_cargo_weight: 'Og‘irlik',
  work_card_cargo_body: 'Kuzov turi',
  work_card_history: 'Tarix',
  work_card_history_empty: 'Tarix hali bo‘sh',
  work_card_track: 'Marshrut izi',
  work_card_track_empty: 'Marshrut nuqtalari hali yo‘q',
  work_card_track_thinned: 'Marshrut siyraklashtirilgan: hamma nuqtalar ko‘rsatilmagan',
  work_card_track_signal: 'Aloqa',
  work_card_track_age: 'Oxirgi nuqta',
  work_card_track_minutes: 'daqiqa oldin',
  work_card_tiles_failed: 'Xarita foni mavjud emas, marshrut chizig‘i usiz ko‘rsatilgan',
  work_card_chat: 'Ish chati',
  work_card_message_text: 'Xabar',
  work_card_message_photo: 'Surat',
  work_card_message_send: 'Yuborish',
  work_card_message_hidden: 'Xabar yashirilgan',
  work_card_messages_more: 'Avvalgilarini ko‘rsatish',
  work_card_messages_empty: 'Xabarlar hali yo‘q',
  work_card_thread: 'Haydovchi bilan yozishma',
  work_card_thread_caption: 'Direktor va dispetcher',
  work_card_thread_open: 'Yozishmani ochish',
  work_card_files: 'Hujjatlar va cheklar',
  work_card_files_empty: 'Fayllar hali yo‘q',
  work_card_file_kind: 'Fayl turi',
  work_card_file_description: 'Fayl tavsifi',
  work_card_file_choose: 'Fayl — surat yoki PDF',
  work_card_file_uploaded: 'Fayl yuklandi',
  work_card_file_edit: 'Tavsifni o‘zgartirish',
  work_card_file_save: 'Saqlash',
  work_card_file_delete: 'O‘chirish',
  work_card_file_delete_question: 'Bu fayl o‘chirilsinmi?',
  work_card_photos: 'Ish suratlari',
  work_card_photos_empty: 'Suratlar hali yo‘q',
  work_card_photo_plate: 'Raqamli kadr',
  work_card_tracking: 'Kuzatuv havolasi',
  work_card_tracking_create: 'Havola yaratish',
  work_card_tracking_revoke: 'Havolani bekor qilish',
  work_card_tracking_revoke_question: 'Havola bekor qilinsinmi? U darhol ishlamay qoladi.',
  work_card_tracking_revoked: 'Havola bekor qilindi',
  work_card_tracking_copy: 'Nusxalash',
  work_card_tracking_copied: 'Nusxalandi',
  work_card_tracking_url: 'Havola',
  work_card_tracking_pin: 'PIN-kod',
  work_card_tracking_once: 'Bir marta ko‘rsatiladi: hozir saqlang. Yangi havola avvalgisini almashtiradi.',
  work_card_rating: 'Baho',
  work_card_rating_score: '1 dan 5 gacha baho',
  work_card_rating_comment: 'Izoh',
  work_card_rating_send: 'Baholash',
  work_card_rating_later: 'Keyinroq baholash',
  work_card_rating_late: 'Baho muddatdan keyin qo‘yilgan',
  work_card_claims: 'Bekor qilish va nizo',
  work_card_cancel_request: 'Bekor qilishni so‘rash',
  work_card_cancel_category: 'Toifa',
  work_card_cancel_reason: 'Sabab',
  work_card_cancel_send: 'So‘rovni yuborish',
  work_card_cancel_respond_by: 'Javob muddati',
  work_card_cancel_accept: 'Bekor qilishni qabul qilish',
  work_card_cancel_accept_question: 'Bekor qilish qabul qilinsinmi? Ish bekor qilinadi.',
  work_card_cancel_decline: 'Rad etish',
  work_card_cancel_withdraw: 'So‘rovni qaytarib olish',
  work_card_dispute: 'Nizo',
  work_card_dispute_open: 'Nizo ochish',
  work_card_dispute_statement: 'Ariza',
  work_card_dispute_send: 'Ariza berish',
  work_card_dispute_outcome: 'Natija',
  work_card_dispute_guilty: 'Aybdor tomon',
  work_card_dispute_note: 'Xodimlar qarori',
  work_card_dispute_message: 'Nizoga xabar',
  work_card_dispute_message_send: 'Xabar qo‘shish',
  work_signal_OK: 'Aloqa bor',
  work_signal_NO_DATA: 'Ma’lumot uzoq vaqtdan beri yo‘q',
  work_signal_LOST: 'Aloqa uzilgan',
  work_file_kind_document: 'Hujjat',
  work_file_kind_receipt: 'Chek',
  work_file_kind_cmr: 'CMR yuk xati',
  work_photo_phase_handover: 'Mashinani qabul qilish',
  work_photo_phase_delivery: 'Topshirish',
  work_photo_phase_loading: 'Yuklash',
  work_photo_phase_unloading: 'Tushirish',
  cancellation_category_VEHICLE_BREAKDOWN: 'Mashina buzilishi',
  cancellation_category_ACCIDENT: 'Avariya',
  cancellation_category_OWNER_DEMAND: 'Egasining talabi',
  cancellation_category_DOCUMENTS_OR_BORDER: 'Hujjatlar yoki chegara',
  cancellation_category_EXECUTOR_FORCE_MAJEURE: 'Ijrochining fors-major holati',
  cancellation_category_CARGO_WITHDRAWN: 'Yuk olib qo‘yilgan',
  cancellation_category_CARGO_NOT_READY: 'Yuk tayyor emas',
  cancellation_category_OTHER: 'Boshqa',
  cancellation_request_status_REQUESTED: 'Javob kutilmoqda',
  cancellation_request_status_ACCEPTED: 'Qabul qilingan',
  cancellation_request_status_REJECTED: 'Rad etilgan',
  cancellation_request_status_WITHDRAWN: 'Qaytarib olingan',
  cancellation_request_status_ESCALATED: 'Nizoga o‘tkazilgan',
  cancellation_request_status_LAPSED: 'Muddat tugagan',
  dispute_status_OPEN: 'Ochiq',
  dispute_status_IN_REVIEW: 'Ko‘rib chiqilmoqda',
  dispute_status_ESCALATED: 'Kattaga o‘tkazilgan',
  dispute_status_RESOLVED: 'Hal qilingan',
  dispute_outcome_CANCEL_WORK: 'Ish bekor qilingan',
  dispute_outcome_KEEP_WORK: 'Ish davom etadi',
  guilty_side_CUSTOMER: 'Buyurtmachi',
  guilty_side_EXECUTOR: 'Ijrochi',
  guilty_side_NONE: 'Aybdor yo‘q',
  dispute_author_customer: 'Buyurtmachi',
  dispute_author_executor: 'Ijrochi',
  dispute_author_support: 'Qo‘llab-quvvatlash',
  work_card_file_uploading: 'Fayl yuklanmoqda…',
  nav_label: 'Bo‘limlar',
  nav_toggle: 'Menyu',
  nav_sign_out: 'Chiqish',
  nav_group_works: 'Ishlar',
  nav_group_cargo: 'Yuklar',
  nav_group_fleet: 'Transport',
  nav_group_money: 'Pul',
  nav_group_company: 'Firma',
  works_column_status: 'Holat',
  works_column_route: 'Yo‘nalish',
  works_column_cargo: 'Yuk',
  works_column_loading: 'Yuklash',
  works_column_vehicle: 'Transport',
  works_column_driver: 'Haydovchi',
  works_column_action: 'Amal',

  // Блок `WEB-3.5`: внутренний заказ.
  works_internal_new: 'Yangi ichki buyurtma',
  internal_work_form_title: 'Ichki buyurtma',
  internal_work_form_weight: 'Og‘irlik, kg',
  internal_work_form_submit: 'Buyurtma yaratish',
  work_internal: 'Ichki',
  work_card_internal_cancel: 'Buyurtmani bekor qilish',
  work_card_internal_cancel_send: 'Shu sabab bilan bekor qilish',
  work_card_internal_cancel_question: 'Buyurtma bekor qilinsinmi? Ish bekor qilinadi, uni qaytarib bo‘lmaydi.',
};
